import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { useLogout } from "../../../features/Authentication/useLogout";
import { useOutsideClick } from "../../../hooks/useOutsideClick";
import styles from "./DropdownProfile.module.css";
import AppLoader from "../AppLoader";

export default function DropdownProfile({
  handleCloseDropdown,
}: {
  handleCloseDropdown: () => void;
}) {
  const { logout, isLoading } = useLogout();
  const { userRole } = useAuth();
  const navigate = useNavigate();
  const ref = useOutsideClick(handleCloseDropdown);

  const handleNavigate = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    e.stopPropagation();
    handleCloseDropdown();
    let to = "/admin/profile";
    if (userRole === "client") {
      to = "/client/profile";
    } else if (userRole === "subClient") {
      to = "/subclient/profile";
    }
    navigate(to);
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <>
      {isLoading && <AppLoader />}
      <div className={styles["dropdown__profile__container"]} ref={ref}>
        <ul className={styles["dropdown__profile__menu"]}>
          <li onClick={(e) => handleNavigate(e)}>Profile</li>
          <li className="error" onClick={handleLogout}>
            Sign Out
          </li>
        </ul>
      </div>
    </>
  );
}
